import {
  setActiveAppToLocalStorage,
  setActiveStandardViewToLocalStorage,
} from "src/helpers/helpers";
import { ACTIVE_VIEW } from "src/utils/constants";
import {
  SET_ACTIVE_APP,
  SET_ACTIVE_STORE,
  SET_ACTIVE_TAB,
  SET_ACTIVE_VIEW,
  SET_INITIALIZED,
} from "../actions/app";

const initialState = {
  message: "hello",
  activeTab: undefined,
  isInitialized: false,
  activeStoreId: undefined,
  activeView: ACTIVE_VIEW.STANDARD,
  activeApp: undefined,
};

const appReducer = (state = initialState, payload) => {
  switch (payload.type) {
    case "HELLO_WORLD":
      return {
        ...state,
        message: "hello world",
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload.payload,
      };
    case SET_ACTIVE_VIEW:
      setActiveStandardViewToLocalStorage(payload.payload);
      return {
        ...state,
        activeView: payload.payload,
      };
    case SET_ACTIVE_APP:
      setActiveAppToLocalStorage(payload.payload);
      return {
        ...state,
        activeApp: payload.payload,
      };
    case SET_INITIALIZED:
      return {
        ...state,
        isInitialized: payload.payload,
      };
    case SET_ACTIVE_STORE:
      return {
        ...state,
        activeStoreId: payload.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
